module.exports = __webpack_public_path__ + "static/media/new-experience.a6114d72.png";